<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnRefreshVisible="true" :btnNewVisible="false"
        :linkConfigurazioni="linkConfigurazione" @refresh="onRefresh">
        <template #toolbar>
            <b-button class="button-new" size="sm" variant="success btn-toolbar float-sm-right sa-margin-right"
                @click="onNew">
                <b-icon icon="plus"></b-icon>
                {{ $t("global.lblBtnNew") }}
            </b-button>
        </template>
        <template #table-filter>
            <div class="sa-list-component-header" style="padding: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <!-- <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <span class="sa-label-data">Struttura</span>
                                <b-form-select v-model="filtroTipologieVisite.codiceStruttura"
                                    :options="struttureOptions" value-field="codiceStruttura" text-field="">
                                    <template #first>
                                        <b-form-select-option :value="'TUTTE'">TUTTE LE STRUTTURE</b-form-select-option>
                                    </template>
</b-form-select>
</b-col>
<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">

    <button class="sa-page-search-component-btn-search" title="Search">
        <i class="fas fa-search"></i>
    </button>
    <button class="sa-page-search-component-btn-reset" @click="resetFiltriConfigurazioneDevice" type="button"><i
            class="fas fa-trash"></i></button>
</b-col>
</b-row> -->
                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <AgendaTipologieListComponent ref="cmpAgendaTipologieVisitaListComponent" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from '../../../../template/sa/components/layout/contents/SaPageLayout.vue';
import AgendaTipologieListComponent from '../components/AgendaTipologieListComponent.vue';
import UtilityMixin from '../../../utility/UtilityMixin';
import toast from '../../../../template/layout/utility/sa-toast';
export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, AgendaTipologieListComponent },
    inject: ["openShowModalLoading", "closeShowModalLoading"],

    data() {
        return {
            linkConfigurazione: "/configurazioneagende",
            pathResource: "/agendatipo",
            filtroSessionStorage: "filtroConfigurazioneAgendaTipologie",
            showModalLoading: false,
            presidio: {},
            filtroTipologieVisite: {},
            struttureOptions: []
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        this.getPresidio();
        me.showModalLoading = true;
        let filtroTipologieVisite = sessionStorage.getItem(this.filtroSessionStorage);
        if (filtroTipologieVisite) {
            me.filtroTipologieVisite = JSON.parse(filtroTipologieVisite);
        }
        //me.filtroTipologieVisite.codiceStruttura = this.presidio.codiceStruttura;
        me.loadData(me.filtroTipologieVisite);
    },
    methods: {
        loadData(filtro) {
            let me = this;
            me.$refs.cmpAgendaTipologieVisitaListComponent.loadData(filtro);
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let filtroTipologieVisite = sessionStorage.getItem(this.filtroSessionStorage);
            if (filtroTipologieVisite) {
                me.filtroTipologieVisite = JSON.parse(filtroTipologieVisite);
            }
            me.loadData(me.filtroTipologieVisite);
        },
        getPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
        resetFiltriConfigurazioneDevice() {
            let me = this;
            me.filtroTipologieVisite = {
                codiceStruttura: this.presidio.codiceStruttura
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem(this.filtroSessionStorage, JSON.stringify(this.filtroTipologieVisite));
            this.$refs.cmpAgendaTipologieVisitaListComponent.loadData();
        },
        onNew() {
            this.$refs.cmpAgendaTipologieVisitaListComponent.onEdit({ id: "-1", imeii: "", sistemaOperativo: "", tipo: "", statoAttuale: "", password: "" });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            console.log(this.presidio);

            me.filtroTipologieVisite.codiceStruttura = this.presidio.codiceStruttura;
            sessionStorage.setItem(this.filtroSessionStorage, JSON.stringify(me.filtroTipologieVisite));

            me.$refs.cmpAgendaTipologieVisitaListComponent.loadData(me.filtroTipologieVisite);
        },
        loadDataUtentiPresidio() {
            let me = this;
            let utente = JSON.parse(sessionStorage.getItem("user"));
            UtilityMixin.methods.loadDataResources("/utentipresidi", { idUtente: utente.id }, me.loadDataUtentiPresidiSuccess, me.loadDataUtentiPresidiError);
        },
        loadDataUtentiPresidiSuccess(response) {
            this.struttureOptions = response.data.data.list;
        },
        loadDataUtentiPresidiError(error) {
            console.log(error);
            toast.error("errore durante il caricamento dei presidi dell'utente")
        },
    },
};
</script>
<style scoped>
.button-new {
    border: 1px solid #218838;
}
</style>
